module.exports = __webpack_public_path__ + "img/slide-2.5a7ac27.jpg";